import React, { FC } from 'react'
import styled from 'styled-components'
import { LottieAnimation, LottieAnimationName } from '../lotties'

const Image = styled.img<{ $width: string; $height: string }>`
    border-radius: 50%;
    width: ${(p) => p.$width};
    height: ${(p) => p.$height};
`

interface Props {
    onClick?: () => void
    width?: string | number
    height?: string | number
    src?: string
    animate?: boolean
}

export const Avatar: FC<Props> = ({
    width = '40px',
    height = '40px',
    src = '',
    onClick,
    animate = true,
}) => {
    width = typeof width === 'number' ? `${width}px` : width
    height = typeof height === 'number' ? `${height}px` : height
    // Use Lottie as placeholder for now
    if (!src) {
        return (
            <LottieAnimation
                animate={animate}
                name={LottieAnimationName.FemaleAvatar}
                width={width}
                height={height}
            />
        )
    }

    return <Image $width={width} $height={height} src={src} onClick={onClick} />
}
